
module.exports = {
    myHost: {
       'host':'https://api-gfc.catchbangladesh.com',
    }
};
